var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-w-full gl-display-flex gl-p-4"},[_c('gl-loading-icon',{staticClass:"gl-pr-4",attrs:{"size":"md","inline":""}}),_vm._v(" "),_c('div',{staticClass:"gl-display-flex gl-align-items-center"},[_vm._v("\n    "+_vm._s(_vm.$options.i18n.preparing)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }